import type { PronunciationScript } from './types'

export const pronunciationPageCopy = {
  pinyin: {
    title: 'Chinese Pinyin chart & trainer',
    metadataTitle: 'Chinese Pinyin Chart & Trainer | Miaozi',
    description:
      'Learn Mandarin Pinyin with audio, tones, real-word practice, and focused pronunciation drills.',
    shortDescription:
      'A compact audio path for Mandarin sounds, tones, and spelling.',
    eyebrow: 'Pinyin trainer',
    primaryLabel: 'Pinyin',
    secondaryLabel: 'Zhuyin',
    introTitle: 'What Pinyin helps you hear',
    intro:
      'Pinyin writes Mandarin sounds with the Latin alphabet. It is a pronunciation guide, not an English spelling system: initials are the starting consonant-like sounds, finals are the vowel or ending sounds, and tones carry meaning on top of the syllable.',
    oneLineIntro:
      'Pinyin uses Latin letters for Mandarin pronunciation, but the sounds do not map one-to-one to English.',
    chartTitle: 'Pinyin sound chart',
    breadcrumb: 'Pinyin'
  },
  zhuyin: {
    title: 'Zhuyin / Bopomofo chart & trainer',
    metadataTitle: 'Zhuyin / Bopomofo Chart & Trainer | Miaozi',
    description:
      'Learn Zhuyin with audio, tones, Pinyin mapping, real Mandarin words, and focused pronunciation drills.',
    shortDescription:
      'A compact audio path for Zhuyin symbols, tones, and spelling.',
    eyebrow: 'Zhuyin trainer',
    primaryLabel: 'Zhuyin',
    secondaryLabel: 'Pinyin',
    introTitle: 'What Zhuyin helps you hear',
    intro:
      'Zhuyin, also called Bopomofo, writes Mandarin sounds with dedicated phonetic symbols. It keeps pronunciation separate from English spelling: initials start the syllable, finals complete it, and tones show the pitch shape.',
    oneLineIntro:
      'Zhuyin uses dedicated symbols for Mandarin pronunciation, so each mark stays close to the sound.',
    chartTitle: 'Zhuyin sound chart',
    breadcrumb: 'Zhuyin'
  }
} satisfies Record<
  PronunciationScript,
  {
    title: string
    metadataTitle: string
    description: string
    shortDescription: string
    eyebrow: string
    primaryLabel: string
    secondaryLabel: string
    introTitle: string
    intro: string
    oneLineIntro: string
    chartTitle: string
    breadcrumb: string
  }
>
